// extracted by mini-css-extract-plugin
module.exports = {"templateContainer":"TemplateDisplay_templateContainer__3s2lD","templateImage":"TemplateDisplay_templateImage__vJXxQ","templateName":"TemplateDisplay_templateName__1w5JD"};